import {DtoMapper} from '@wemogy/reactbase';
import {IUser} from '../../models/User';

export default class UserDtoMapper extends DtoMapper<IUser, any>{

}
